import { BehaviorSubject, Observable } from 'rxjs';
import { skipWhile } from 'rxjs/operators';
import * as dialog from '@/subjects/dialog';
import { ENDPOINTS } from '@/settings/api-settings';

const Logout$ = new BehaviorSubject('initialize');

function logout(): void {
  Logout$.next('logout');
}

function sessionExpired(url:string): void {
  if (url && url == ENDPOINTS.LOGIN) {
    return;
  }
  dialog.show(
    'alert',
    'Sessão expirada',
    'Por favor realize o login e tente novamente.',
    'Ok',
    () => {
      window.location.reload();
    },
    '',
    null,
  );
  Logout$.next('logout');
}

function get(): Observable<any> {
  return Logout$.pipe(skipWhile((val) => val !== 'logout'));
}

export { logout, sessionExpired, get };
